// Lumina (23.10.2026): płynne przewijanie kółkiem myszy na komputerze. Strona nie skacze o kawałek, tylko dopływa
// do celu i miękko wyhamowuje. Telefon i tablet (dotyk) bez zmian. Wyłączone przy „ogranicz ruch”, przy Ctrl (powiększanie),
// przy przewijaniu w bok i wewnątrz przewijanych okienek (koszyk, menu, listy). Klawiatura, pasek przewijania i linki
// do sekcji działają natywnie; skrypt się z nimi synchronizuje.
(function () {
  if (window.__lnPlynne) return;
  var mysz = window.matchMedia('(hover: hover) and (pointer: fine)');
  var malyRuch = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!mysz.matches || malyRuch.matches) return;
  window.__lnPlynne = true;

  var SILA = 7;          // im więcej, tym szybciej dopływa (ok. 0,6 s do zatrzymania)
  var cel = window.scrollY, teraz = cel, ustawione = cel, anim = 0, ostatnia = 0;

  function maks() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }

  // czy element pod kursorem sam się przewija w tym kierunku (koszyk, menu, lista kolorów, pole tekstowe)
  function przewijaneWnetrze(el, dy) {
    while (el && el !== document.body && el !== document.documentElement) {
      if (el.nodeType === 1) {
        var s = getComputedStyle(el);
        if (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight + 1) {
          if (dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0) return true;
        }
        if (el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  function zablokowane() {
    // otwarty koszyk wysuwany, menu albo okno: strona pod spodem stoi
    var b = document.body;
    return b.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden-tablet') ||
      getComputedStyle(b).overflowY === 'hidden' || getComputedStyle(document.documentElement).overflowY === 'hidden';
  }

  function krok(t) {
    var dt = ostatnia ? Math.min(0.05, (t - ostatnia) / 1000) : 0.016;
    ostatnia = t;
    // ktoś przewinął inaczej (klawiatura, pasek, link do sekcji): oddaję mu stronę
    if (Math.abs(window.scrollY - ustawione) > 3) { cel = teraz = ustawione = window.scrollY; anim = 0; ostatnia = 0; return; }
    teraz += (cel - teraz) * (1 - Math.exp(-dt * SILA));
    if (Math.abs(cel - teraz) < 0.5) teraz = cel;
    ustawione = Math.round(teraz);
    window.scrollTo({ top: ustawione, behavior: 'instant' });
    if (teraz !== cel) anim = requestAnimationFrame(krok); else { anim = 0; ostatnia = 0; }
  }

  window.addEventListener('wheel', function (e) {
    if (e.defaultPrevented || e.ctrlKey || malyRuch.matches) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    if (zablokowane() || przewijaneWnetrze(e.target, e.deltaY)) return;
    // tylko kółko myszy (skoki po 120 w wheelDeltaY albo przewijanie liniami w Firefoksie);
    // płytka dotykowa w laptopie ma własny rozpęd, więc przepuszczam ją natywnie
    var kolko = e.deltaMode === 1 || (e.wheelDeltaY && Math.abs(e.wheelDeltaY) % 120 === 0);
    if (!kolko) return;
    var dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1);
    e.preventDefault();
    if (!anim) { cel = teraz = ustawione = window.scrollY; }
    cel = Math.max(0, Math.min(maks(), cel + dy));
    if (!anim) anim = requestAnimationFrame(krok);
  }, { passive: false });

  window.addEventListener('scroll', function () {
    if (!anim) { cel = teraz = ustawione = window.scrollY; }
  }, { passive: true });
  window.addEventListener('resize', function () { cel = Math.min(cel, maks()); });
  if (malyRuch.addEventListener) malyRuch.addEventListener('change', function () { if (malyRuch.matches && anim) { cancelAnimationFrame(anim); anim = 0; } });
})();
